module.exports = __webpack_public_path__ + "media/images/amaia_valley_logo-722e1eaaecf38ed5ed15388b4a8d8ec9.png";